import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/angular': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M185.7 268.1l38.1-91.6 38.1 91.6h-76.2zM223.8 32l207.8 74.4-31.8 275.7-176 97.9-176-97.9-31.8-275.7zM354 373.8l-130.2-292.3-130.1 292.3h48.7l26.2-65.4h110.6l26.2 65.4h48.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/angular.js
// module id = 709
// module chunks = 0